<template>
  <div class="wrap" :style="{height: setHeight}">
    <img src="../../../assets/image/no-data.png" style="width:90px;">
    <p class="title" v-if="errTitle">{{errTitle}}</p>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    errTitle: {
      default: ''
    },
    setHeight: {
      default: 'auto'
    }
  }
}
</script>

<style scoped lang="less">
.wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.title{
  font-size: 14px !important;
  color: #999;
  margin-left: -10px;
}
</style>
